import { REVIEW_PAGE_LOADED, SUBMIT_FEEDBACK } from './constants';

export function submitFeedback() {
  return { type: SUBMIT_FEEDBACK };
}

export function reviewPageLoaded() {
  return { type: REVIEW_PAGE_LOADED };
}
